import React from 'react'

import { useSubscriptionsQueries } from 'src/hooks/services/microsoft/queries/useSubscriptionsQuery'
import { useTenantsQuery } from '~/hooks/services/servicenow/queries/useTenantsQuery'

import { isExpiringSoon } from 'src/utils/subscriptions'

import moment from 'moment'
import { IoRefreshOutline } from 'react-icons/io5'
import { useNavigate } from 'react-router-dom'

import { Tile, TileFooter, TileHeader, TileListContent, TileListItem } from '../Tile'

const AutoRenewingLicensesTile = () => {
  const navigate = useNavigate()

  const { data: tenants = [], isLoading: isTenantsLoading } = useTenantsQuery()
  const subscriptionsQueries = useSubscriptionsQueries(tenants.map((tenant) => tenant.id))

  const subscriptionsWithTenants = subscriptionsQueries
    .map((query, index) => {
      const tenant = tenants[index]
      return (query.data ?? []).map((subscription) => ({
        ...subscription,
        tenant
      }))
    })
    .flat()
    .filter((sub) => isExpiringSoon(sub) && sub.AutoRenewEnabled)

  return (
    <Tile onMouseDown={() => navigate('/subscriptions?filter=renewal-enabled')}>
      <TileHeader loading={isTenantsLoading || subscriptionsQueries.some((query) => query.isLoading)}>
        <TileHeader.Title>{subscriptionsWithTenants.length}</TileHeader.Title>
        <TileHeader.Subtitle>Microsoft 365 Licenses Auto-Renewing Soon</TileHeader.Subtitle>
        <TileHeader.Item>
          <IoRefreshOutline className="h-10 w-10 text-th-success" />
        </TileHeader.Item>
      </TileHeader>
      <TileListContent limit={3} bordered>
        {subscriptionsWithTenants.map((sub) => (
          <TileListItem key={sub.Id}>
            <TileListItem.Title>{sub.FriendlyName}</TileListItem.Title>
            <TileListItem.Subtitle>
              {sub.tenant.name}
              <span className="text-th-text-secondary">Renews {moment(sub.CommitmentEndDate).format('DD/MM/YYYY')}</span>
            </TileListItem.Subtitle>
          </TileListItem>
        ))}
      </TileListContent>
      {subscriptionsWithTenants.length > 3 && <TileFooter>View {subscriptionsWithTenants.length - 3} more...</TileFooter>}
    </Tile>
  )
}

export default AutoRenewingLicensesTile
